var render = function render(){var _vm=this,_c=_vm._self._c;return _c('get-report',{attrs:{"page-type":"maintenance"}})
}
var staticRenderFns = []

export { render, staticRenderFns }